import { SelectedPortInput } from './selected-port-input.model';


export class DeviceUpdateInput implements IDeviceUpdateInput {
    /** The auto-generated id of the device master */
    deviceId!: number;
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;
    /** The auto-generated id of the user master */
    userId!: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;
    /** The vehicle odometer */
    odometer!: number;
    /** The auto-generated id of the sim card details master */
    simCardDetailsId!: number;
    /** The auto-generated id of the sim card details master */
    secondarySimCardDetailsId!: number;
    /** The IMEI number with 500 character */
    imeiNumber!: string;
    /** The auto-generated id of the sim card details master" */
    deviceModelId!: number;
    /** The ignore heart beat data 0 for unselected, 1 for selected */
    ignoreHeartBeatData!: number;
    /** The ign based on speed 0 for unselected, 1 for selected */
    ignBasedOnSpeed!: number;
    /** The auto-generated id of the time zone master" */
    timeZoneId!: number;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicleLicense!: number;
    /** The expiry date should be with 10 character */
    expiryDate!: string;
    /** The notify 0 for unselected, 1 for selected */
    notify!: number;
    /** The show expiryMessage days */
    showExpiryMessageDays!: number;
    /** The installation date should be with 10 character */
    installationDate!: string;
    /** The fuel consumption based on  should be  "Distance" or "Duration" */
    fuelConsumptionBasedOn!: string;
    /** The fuel consumption with 200 character limit */
    fuelConsumption!: string;
    selectedPort!: SelectedPortInput[];

    constructor(data?: IDeviceUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.branchDetailId = _data["branchDetailId"];
            this.userId = _data["userId"];
            this.vehicleDetailsId = _data["vehicleDetailsId"];
            this.odometer = _data["odometer"];
            this.simCardDetailsId = _data["simCardDetailsId"];
            this.secondarySimCardDetailsId = _data["secondarySimCardDetailsId"];
            this.imeiNumber = _data["imeiNumber"];
            this.deviceModelId = _data["deviceModelId"];
            this.ignoreHeartBeatData = _data["ignoreHeartBeatData"];
            this.ignBasedOnSpeed = _data["ignBasedOnSpeed"];
            this.timeZoneId = _data["timeZoneId"];
            this.vehicleLicense = _data["vehicleLicense"];
            this.expiryDate = _data["expiryDate"];
            this.notify = _data["notify"];
            this.showExpiryMessageDays = _data["showExpiryMessageDays"];
            this.installationDate = _data["installationDate"];
            this.fuelConsumptionBasedOn = _data["fuelConsumptionBasedOn"];
            this.fuelConsumption = _data["fuelConsumption"];
            if (Array.isArray(_data["selectedPort"])) {
                this.selectedPort = [] as any;
                for (let item of _data["selectedPort"])
                    this.selectedPort!.push(SelectedPortInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["branchDetailId"] = this.branchDetailId;
        data["userId"] = this.userId;
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        data["odometer"] = this.odometer;
        data["simCardDetailsId"] = this.simCardDetailsId;
        data["secondarySimCardDetailsId"] = this.secondarySimCardDetailsId;
        data["imeiNumber"] = this.imeiNumber;
        data["deviceModelId"] = this.deviceModelId;
        data["ignoreHeartBeatData"] = this.ignoreHeartBeatData;
        data["ignBasedOnSpeed"] = this.ignBasedOnSpeed;
        data["timeZoneId"] = this.timeZoneId;
        data["vehicleLicense"] = this.vehicleLicense;
        data["expiryDate"] = this.expiryDate;
        data["notify"] = this.notify;
        data["showExpiryMessageDays"] = this.showExpiryMessageDays;
        data["installationDate"] = this.installationDate;
        data["fuelConsumptionBasedOn"] = this.fuelConsumptionBasedOn;
        data["fuelConsumption"] = this.fuelConsumption;
        if (Array.isArray(this.selectedPort)) {
            data["selectedPort"] = [];
            for (let item of this.selectedPort)
                data["selectedPort"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceUpdateInput {
    /** The auto-generated id of the device master */
    deviceId: number;
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
    /** The auto-generated id of the user master */
    userId: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
    /** The vehicle odometer */
    odometer: number;
    /** The auto-generated id of the sim card details master */
    simCardDetailsId: number;
    /** The auto-generated id of the sim card details master */
    secondarySimCardDetailsId: number;
    /** The IMEI number with 500 character */
    imeiNumber: string;
    /** The auto-generated id of the sim card details master" */
    deviceModelId: number;
    /** The ignore heart beat data 0 for unselected, 1 for selected */
    ignoreHeartBeatData: number;
    /** The ign based on speed 0 for unselected, 1 for selected */
    ignBasedOnSpeed: number;
    /** The auto-generated id of the time zone master" */
    timeZoneId: number;
    /** The vehicle license 0 for unselected, 1 for selected */
    vehicleLicense: number;
    /** The expiry date should be with 10 character */
    expiryDate: string;
    /** The notify 0 for unselected, 1 for selected */
    notify: number;
    /** The show expiryMessage days */
    showExpiryMessageDays: number;
    /** The installation date should be with 10 character */
    installationDate: string;
    /** The fuel consumption based on  should be  "Distance" or "Duration" */
    fuelConsumptionBasedOn: string;
    /** The fuel consumption with 200 character limit */
    fuelConsumption: string;
    selectedPort: SelectedPortInput[];
}

